
















import {
  Vue,
  Component
} from "@/shared/vuepack";

@Component
export default class LoadingSpinner extends Vue {}

